import { useEffect } from 'react';
import useRequestState from '../../hooks/useRequestState';
import customIcons from '../../utils/icons';
import { HeadlineCardInterface } from '../../types/global';
import SkeletonCard from './skeletonCard';
import SummaryHeadlineCard from './summaryHeadlineCard';
import PostHeadlineCardData from '../../services/adapters/headlineCard';

type HeadlineGraphRequest = {
  snapshot: string;
  liftDataId: string;
  wardName: string;
};

const skeletonCards = ['first', 'second', 'third', 'fourth'];

export default function SummaryHeadlineCardContainer({ snapshot, liftDataId, wardName }: Readonly<HeadlineGraphRequest>) {
  const {
    data,
    error,
    loading,
    handleRequest: handleHeadlineCardRequest,
  } = useRequestState<HeadlineCardInterface[]>();

  useEffect(() => {
    const fetchHeadlineCards = async () => {
      const headlineAdapter = new PostHeadlineCardData();
      const headlineResponse = headlineAdapter.adaptResponse({ snapshot, liftDataId, wardName });
      await handleHeadlineCardRequest(headlineResponse);
    };
    void fetchHeadlineCards();
  }, [snapshot, liftDataId, wardName]);

  if (loading) {
    return skeletonCards.map((card) => <SkeletonCard key={card} skeletonRows={['first']} />);
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center grow min-w-37.5 flex-1 card font-normal">
        <span title={error.message} className="text-2xl text-pipstatus-alert">{customIcons.errorIcon}</span>
      </div>
    );
  }

  return data?.map((HeadlineCard) => (
    <SummaryHeadlineCard key={HeadlineCard.title} headlineCardData={HeadlineCard} headlineGraphRequest={{ snapshot, liftDataId, wardName }} />
  ));
}
